import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class PhotographerForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      photographer: [''],
      startPageFile: [''],
      smilePageFile: [''],
      donePageFile: [''],
      startPageS3: [''],
      smilePageS3: [''],
      donePageS3: [''],
      backgroundColor: [''],
      fontColor: [''],
      fontStyle: [''],
    });
  }
}
